import { useGT } from 'gt-react';
import { useDemoOrderNumbers } from './demoOrderNumbers';

/** The real number, else (demo mode only) a made-up one, else a dash. */
export function OrderNumberCell({
  value,
  demo,
}: {
  value: string | null;
  demo: () => string;
}) {
  const demoNumbers = useDemoOrderNumbers();
  if (value !== null) return value;
  return demoNumbers ? <DemoOrderNumber value={demo()} /> : '—';
}

/**
 * A made-up order number (see `demoOrderNumbers.ts`), dashed-underlined so it
 * can't pass for a real one. Screen readers get the explanation as text, since
 * a `title` alone is never announced.
 */
export function DemoOrderNumber({ value }: { value: string }) {
  const gt = useGT();
  const explanation = gt('Demo number, not a real order yet', {
    context: 'tooltip on a made-up order number shown only in demo mode',
  });
  return (
    <span
      className="underline decoration-muted-foreground decoration-dashed underline-offset-2"
      title={explanation}
    >
      {value}
      <span className="sr-only"> ({explanation})</span>
    </span>
  );
}
